import { getSceneImage } from "@/components/IslandScene";

const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
});

const drawCover = (ctx, img, W, H) => {
  const s = Math.max(W / img.width, H / img.height);
  const w = img.width * s, h = img.height * s;
  ctx.drawImage(img, (W - w) / 2, (H - h) / 2, w, h);
};

export async function shareIsland(islandType, islandName) {
  const W = 1080, H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");

  const scene = await loadImage(getSceneImage(islandType, false));
  drawCover(ctx, scene, W, H);

  // top + bottom cinematic gradients
  let g = ctx.createLinearGradient(0, 0, 0, 260);
  g.addColorStop(0, "rgba(4,8,20,0.55)"); g.addColorStop(1, "rgba(4,8,20,0)");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, 260);
  g = ctx.createLinearGradient(0, H - 520, 0, H);
  g.addColorStop(0, "rgba(4,8,20,0)"); g.addColorStop(1, "rgba(4,8,20,0.88)");
  ctx.fillStyle = g; ctx.fillRect(0, H - 520, W, 520);

  // logo top-left
  try {
    const logo = await loadImage("/images/ade-logo-extracted.png");
    ctx.drawImage(logo, 48, 44, 110, 110);
  } catch {}

  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(255,255,255,0.75)";
  ctx.font = "600 34px -apple-system, 'Segoe UI', sans-serif";
  ctx.fillText("VIENI A TROVARMI SULLA MIA ISOLA", W / 2, H - 320);

  ctx.fillStyle = "#ffffff";
  ctx.font = "800 92px -apple-system, 'Segoe UI', sans-serif";
  ctx.shadowColor = "rgba(0,0,0,0.5)"; ctx.shadowBlur = 24;
  ctx.fillText(islandName, W / 2, H - 210);
  ctx.shadowBlur = 0;

  // pill "Cercala su ADE Island"
  const pillW = 560, pillH = 84, px = (W - pillW) / 2, py = H - 160;
  ctx.beginPath();
  if (ctx.roundRect) ctx.roundRect(px, py, pillW, pillH, 42);
  else ctx.rect(px, py, pillW, pillH);
  const pg = ctx.createLinearGradient(px, py, px + pillW, py);
  pg.addColorStop(0, "#ec4899"); pg.addColorStop(1, "#f97316");
  ctx.fillStyle = pg; ctx.fill();
  ctx.fillStyle = "#ffffff";
  ctx.font = "700 40px -apple-system, 'Segoe UI', sans-serif";
  ctx.fillText("Cercala su ADE Island", W / 2, py + 55);

  const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", 0.9));
  const file = new File([blob], `isola-${islandName}.jpg`, { type: "image/jpeg" });
  const shareData = {
    files: [file],
    title: "La mia isola su ADE",
    text: `Vieni a trovarmi su ADE! Cerca l'isola "${islandName}"`,
  };
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share(shareData); return "shared"; }
    catch (e) { if (e.name === "AbortError") return "cancelled"; }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `isola-${islandName}.jpg`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return "downloaded";
}
